import ar_SA from 'antd/lib/locale';
import saMessages from '../locales/ar_SA.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: ar_SA,
  locale: 'ar',
};
export default saLang;
